import type { StoreProductReapproParamUpsert, XlsxImportResponse } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const upsertStoreProductReapproParam = async (data: StoreProductReapproParamUpsert) => {
  const response = await gozokiApiWithAuth.put('/store-product-reappro-params', data)
  return response.data
}

export const exportReapproStockMinimumToXlsx = async (): Promise<Blob> => {
  const response = await gozokiApiWithAuth.get(
    '/store-product-reappro-params/export-stock-minimum-xlsx',
    { responseType: 'blob' },
  )
  return response.data
}

export const importReapproStockMinimumFromXlsx = async (
  file: File,
): Promise<XlsxImportResponse> => {
  const formData = new FormData()
  formData.append('importFile', file)
  const response = await gozokiApiWithAuth.post<XlsxImportResponse>(
    '/store-product-reappro-params/import-stock-minimum-xlsx',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return response.data
}
